import React from 'react'
import { IonIcon } from '@ionic/react'

const YokIcon = ({ name, ...props }) => {
  const icon = require(`../../../assets/svg/${name}.svg`)
  return <IonIcon src={icon.default} {...props} />
}

export default YokIcon
